import { render, staticRenderFns } from "./FoodMenu.vue?vue&type=template&id=ead2585e&"
import script from "./FoodMenu.vue?vue&type=script&lang=ts&"
export * from "./FoodMenu.vue?vue&type=script&lang=ts&"
import style0 from "./FoodMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports